import { render, staticRenderFns } from "./PosturasStatusContainer.vue?vue&type=template&id=78710047"
import script from "./PosturasStatusContainer.vue?vue&type=script&lang=js"
export * from "./PosturasStatusContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports